module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-ties-remnants.7642b83e.png";